<template>
  <div class="borrow-request-management">
    <!-- <div class="page-header">
      <h2>借用申请管理</h2>
    </div> -->
    
    <!-- 筛选栏 -->
    <div class="filter-bar">
      <div class="filter-row">
        <el-select
          v-model="selectedStatus"
          placeholder="选择状态"
          style="width: 200px; margin-right: 10px;"
          clearable
          @change="handleFilterChange"
        >
          <el-option label="全部" value="" />
                <el-option label="待审批" value="PENDING" />
                <el-option label="已批准" value="APPROVED" />
                <el-option label="已拒绝" value="REJECTED" />
                <el-option label="已借出" value="BORROWED" />
                <el-option label="申请归还" value="PENDING_RETURN" />
                <el-option label="已归还" value="RETURNED" />
          <el-option label="已逾期" value="OVERDUE" />
          <el-option label="已取消" value="CANCELLED" />
        </el-select>
        
        <el-input
          v-model="searchRealName"
          placeholder="输入真实姓名查询"
          style="width: 200px; margin-right: 10px;"
          clearable
          @input="handleFilterChange"
          @clear="handleFilterChange"
        >
          <template #prefix>
            <el-icon><User /></el-icon>
          </template>
        </el-input>
        
        <el-input
          v-model="searchDeviceName"
          placeholder="输入设备名称查询"
          style="width: 200px; margin-right: 10px;"
          clearable
          @input="handleFilterChange"
          @clear="handleFilterChange"
        >
          <template #prefix>
            <el-icon><Monitor /></el-icon>
          </template>
        </el-input>
        
        <el-button @click="handleSearch" type="primary">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button @click="fetchBorrowRequests">刷新</el-button>
        <el-button @click="exportToExcel" type="success" :loading="exporting">
          <el-icon><Download /></el-icon>
          导出Excel
        </el-button>
        <el-button type="info" @click="openFlowDialog" style="margin-left: 8px;">
          流程说明
        </el-button>
      </div>
    </div>
    
    <!-- 借用申请列表 -->
    <div class="request-list">
      <el-table 
        :data="borrowRequests" 
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column label="申请ID" width="80" align="center">
          <template #default="scope">
            <span style="font-weight: 600; color: #409EFF;">
              {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="用户名" width="120" />
        <el-table-column label="真实姓名" width="120">
          <template #default="scope">
            {{ scope.row.userRealName || scope.row.userNickname || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="deviceName" label="设备名称" width="150" />
        <el-table-column prop="deviceNumber" label="设备编号" width="120" />
        <el-table-column prop="borrowReason" label="借用原因" width="200" show-overflow-tooltip />
        <el-table-column prop="borrowDuration" label="借用天数" width="100" />
        <el-table-column prop="returnTime" label="实际归还时间" width="180">
          <template v-slot="scope">
            {{ scope.row.returnTime ? formatDateTime(scope.row.returnTime) : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template #default="scope">
            <el-tag :type="getStatusTagType(scope.row.status || '')">
              {{ getStatusText(scope.row.status || '') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="requestTime" label="申请时间" width="180">
          <template #default="scope">
            {{ formatDateTime(scope.row.requestTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="expectedReturnTime" label="预期归还时间" width="180">
          <template #default="scope">
            {{ formatDateTime(scope.row.expectedReturnTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="deviceUsage" label="仪器使用情况" width="200" show-overflow-tooltip>
          <template #default="scope">
            {{ scope.row.deviceUsage || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="scope">
            <div v-if="scope.row.status === 'PENDING'">
              <el-button 
                type="success" 
                size="small" 
                @click="showApprovalDialog(scope.row, true)"
              >
                批准
              </el-button>
              <el-button 
                type="danger" 
                size="small" 
                @click="showApprovalDialog(scope.row, false)"
                style="margin-left: 5px;"
              >
                拒绝
              </el-button>
            </div>
            <div v-else-if="scope.row.status === 'PENDING_RETURN'">
              <el-button 
                type="success" 
                size="small" 
                @click="showReturnApprovalDialog(scope.row, true)"
              >
                批准归还
              </el-button>
              <el-button 
                type="danger" 
                size="small" 
                @click="showReturnApprovalDialog(scope.row, false)"
                style="margin-left: 5px;"
              >
                拒绝归还
              </el-button>
            </div>
            <el-button 
              type="info" 
              size="small" 
              @click="showDetailDialog(scope.row)"
            >
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    
    <!-- 审批对话框 -->
    <el-dialog
      v-model="approvalDialogVisible"
      :title="approvalForm.approved ? '批准申请' : '拒绝申请'"
      width="500px"
    >
      <el-form :model="approvalForm" label-width="100px">
        <el-form-item label="申请人">
          <span>{{ approvalForm.userName }}</span>
        </el-form-item>
        <el-form-item label="设备">
          <span>{{ approvalForm.deviceName }} ({{ approvalForm.deviceNumber }})</span>
        </el-form-item>
        <el-form-item label="借用原因">
          <span>{{ approvalForm.borrowReason }}</span>
        </el-form-item>
        <el-form-item label="借用天数">
          <span>{{ approvalForm.borrowDuration }}天</span>
        </el-form-item>
        <el-form-item label="管理员备注">
          <el-input
            v-model="approvalForm.adminRemark"
            type="textarea"
            :rows="3"
            :placeholder="approvalForm.approved ? '批准备注（可选）' : '拒绝原因（必填）'"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="approvalDialogVisible = false">取消</el-button>
          <el-button 
            :type="approvalForm.approved ? 'success' : 'danger'"
            @click="submitApproval"
            :loading="submitting"
          >
            {{ approvalForm.approved ? '批准' : '拒绝' }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 归还审批对话框 -->
    <el-dialog
      v-model="returnApprovalDialogVisible"
      :title="returnApprovalForm.approved ? '批准归还' : '拒绝归还'"
      width="500px"
    >
      <el-form :model="returnApprovalForm" label-width="100px">
        <el-form-item label="申请人">
          <span>{{ returnApprovalForm.userName }}</span>
        </el-form-item>
        <el-form-item label="设备">
          <span>{{ returnApprovalForm.deviceName }} ({{ returnApprovalForm.deviceNumber }})</span>
        </el-form-item>
        <el-form-item label="仪器使用情况">
          <span>{{ returnApprovalForm.deviceUsage || '无' }}</span>
        </el-form-item>
        <el-form-item label="管理员备注">
          <el-input
            v-model="returnApprovalForm.adminRemark"
            type="textarea"
            :rows="3"
            :placeholder="returnApprovalForm.approved ? '批准备注（可选）' : '拒绝原因（必填）'"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="returnApprovalDialogVisible = false">取消</el-button>
          <el-button 
            :type="returnApprovalForm.approved ? 'success' : 'danger'"
            @click="submitReturnApproval"
            :loading="returnSubmitting"
          >
            {{ returnApprovalForm.approved ? '批准归还' : '拒绝归还' }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    
    <!-- 详情对话框 -->
    <el-dialog
      v-model="detailDialogVisible"
      title="申请详情"
      width="600px"
    >
      <el-descriptions :column="2" border>
        <el-descriptions-item label="申请ID">{{ detailForm.id }}</el-descriptions-item>
        <el-descriptions-item label="申请人">{{ detailForm.userName }}</el-descriptions-item>
        <el-descriptions-item label="设备名称">{{ detailForm.deviceName }}</el-descriptions-item>
        <el-descriptions-item label="设备编号">{{ detailForm.deviceNumber }}</el-descriptions-item>
        <el-descriptions-item label="借用天数">{{ detailForm.borrowDuration }}天</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="getStatusTagType(detailForm.status || '')">
            {{ getStatusText(detailForm.status || '') }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="申请时间" :span="2">
          {{ formatDateTime(detailForm.requestTime) }}
        </el-descriptions-item>
        <el-descriptions-item label="预期归还时间" :span="2">
          {{ formatDateTime(detailForm.expectedReturnTime) }}
        </el-descriptions-item>
        <el-descriptions-item label="实际归还时间" :span="2" v-if="detailForm.returnTime">
          {{ formatDateTime(detailForm.returnTime) }}
        </el-descriptions-item>
        <el-descriptions-item label="借用原因" :span="2">
          {{ detailForm.borrowReason || '无' }}
        </el-descriptions-item>
        <el-descriptions-item label="仪器使用情况" :span="2">
          {{ detailForm.deviceUsage || '无' }}
        </el-descriptions-item>
        <el-descriptions-item label="管理员备注" :span="2" v-if="detailForm.adminRemark">
          {{ detailForm.adminRemark }}
        </el-descriptions-item>
        <el-descriptions-item label="审批时间" :span="2" v-if="detailForm.approvedAt">
          {{ formatDateTime(detailForm.approvedAt) }}
        </el-descriptions-item>
        <el-descriptions-item label="配件信息" :span="2" v-if="detailForm.accessories && detailForm.accessories.length > 0">
          <div class="accessories-info">
            <el-tag 
              v-for="accessory in detailForm.accessories" 
              :key="accessory.id"
              type="info"
              class="accessory-tag"
            >
              {{ accessory.name }} × {{ accessory.quantity }}
            </el-tag>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="配件信息" :span="2" v-else>
          <span class="no-accessories">无配件</span>
        </el-descriptions-item>
        <el-descriptions-item label="归还照片" :span="2">
          <div v-if="detailReturnPhotos && detailReturnPhotos.length > 0" class="return-photos">
            <el-image
              v-for="(photo, idx) in detailReturnPhotos"
              :key="idx"
              :src="photo"
              :preview-src-list="detailReturnPhotos"
              fit="cover"
              class="return-photo"
            />
          </div>
          <span v-else class="no-accessories">无照片</span>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>

    <!-- 流程说明对话框 -->
    <el-dialog
      v-model="flowDialogVisible"
      title="流程说明"
      width="600px"
    >
      <div class="flow-doc">
        <ol>
          <li>用户提交借用申请。</li>
          <li>管理员在“待审批”状态审批：批准或拒绝。</li>
          <li>批准后进入“已借出”，到期或实际归还前，用户发起归还申请。</li>
          <li>记录进入“申请归还”，管理员进行归还审批。</li>
          <li>批准归还：更新为“已归还”，记录实际归还时间。</li>
          <li>拒绝归还：需填写拒绝原因，提示用户补充说明后再申请。</li>
          <li>建议：审批前核对“仪器使用情况”和“归还照片”。</li>
        </ol>
        <div style="margin-top:8px;color:#606266;">
          接口路径：借用审批 <code>/api/borrow-requests/{id}/approve</code> ，归还审批 <code>/api/borrow-requests/{id}/approve-return</code>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="flowDialogVisible = false">知道了</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { User, Monitor, Download } from '@element-plus/icons-vue'
import * as XLSX from 'xlsx'

export default {
  name: 'BorrowRequestManagement',
  components: {
    User,
    Monitor,
    Download
  },
  data() {
    return {
      borrowRequests: [],
      loading: false,
      selectedStatus: '',
      searchRealName: '',
      searchDeviceName: '',
      searchTimeout: null,
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,
      approvalDialogVisible: false,
      returnApprovalDialogVisible: false,
      detailDialogVisible: false,
      flowDialogVisible: false,
      submitting: false,
      returnSubmitting: false,
      approvalForm: {
        id: null,
        userName: '',
        deviceName: '',
        deviceNumber: '',
        borrowReason: '',
        borrowDuration: 0,
        approved: true,
        adminRemark: ''
      },
      returnApprovalForm: {
        id: null,
        userName: '',
        deviceName: '',
        deviceNumber: '',
        deviceUsage: '',
        approved: true,
        adminRemark: ''
      },
      detailForm: {},
      detailReturnPhotos: [],
      exporting: false
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  mounted() {
    this.fetchBorrowRequests()
  },
  
  beforeUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  },
  methods: {
    async fetchBorrowRequests() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage - 1, // 后端通常从0开始
          size: this.pageSize
        }
        if (this.selectedStatus) {
          params.status = this.selectedStatus
        }
        if (this.searchRealName && this.searchRealName.trim()) {
          params.realName = this.searchRealName.trim()
        }
        if (this.searchDeviceName && this.searchDeviceName.trim()) {
          params.deviceName = this.searchDeviceName.trim()
        }
        
        const response = await axios.get('/api/admin/borrow-records', { params })
        
        this.borrowRequests = response.data.data || []
        this.total = response.data.total || 0
      } catch (error) {
        this.$message.error('获取借用申请失败')
      } finally {
        this.loading = false
      }
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.currentPage = 1
      this.fetchBorrowRequests()
    },
    
    handleCurrentChange(newPage) {
      this.currentPage = newPage
      this.fetchBorrowRequests()
    },
    
    handleFilterChange() {
      // 防抖处理，避免频繁请求
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1 // 重置到第一页
        this.fetchBorrowRequests()
      }, 500)
    },
    
    handleSearch() {
      this.currentPage = 1 // 重置到第一页
      this.fetchBorrowRequests()
    },
    
    handleReset() {
      this.selectedStatus = ''
      this.searchRealName = ''
      this.searchDeviceName = ''
      this.currentPage = 1
      this.fetchBorrowRequests()
    },
    
    showApprovalDialog(request, approved) {
      this.approvalForm = {
        id: request.id,
        userName: request.userName,
        deviceName: request.deviceName,
        deviceNumber: request.deviceNumber,
        borrowReason: request.borrowReason,
        borrowDuration: request.borrowDuration,
        approved: approved,
        adminRemark: ''
      }
      this.approvalDialogVisible = true
    },
    
    showDetailDialog(request) {
      this.detailForm = { ...request }
      this.detailReturnPhotos = this.getReturnPhotoList(request).map(this.toAbsoluteUrl)
      this.detailDialogVisible = true
    },

    openFlowDialog() {
      this.flowDialogVisible = true
    },

    showReturnApprovalDialog(request, approved) {
      this.returnApprovalForm = {
        id: request.id,
        userName: request.userName,
        deviceName: request.deviceName,
        deviceNumber: request.deviceNumber,
        deviceUsage: request.deviceUsage || '',
        approved: approved,
        adminRemark: ''
      }
      this.returnApprovalDialogVisible = true
    },
    
    async submitApproval() {
      if (!this.approvalForm.approved && !this.approvalForm.adminRemark.trim()) {
        this.$message.warning('拒绝申请时必须填写拒绝原因')
        return
      }
      
      this.submitting = true
      try {
        const response = await axios.put(`/api/admin/borrow-records/${this.approvalForm.id}/approve`, {
          approved: this.approvalForm.approved,
          adminRemark: this.approvalForm.adminRemark
        })
        
        if (response.data.success) {
          this.$message.success(response.data.message)
          this.approvalDialogVisible = false
          this.fetchBorrowRequests()
        } else {
          this.$message.error(response.data.message || '审批失败')
        }
      } catch (error) {
        this.$message.error('审批失败')
      } finally {
        this.submitting = false
      } 
    },

    async submitReturnApproval() {
      if (!this.returnApprovalForm.approved && !this.returnApprovalForm.adminRemark.trim()) {
        this.$message.warning('拒绝归还时必须填写原因')
        return
      }
      this.returnSubmitting = true
      try {
        const response = await axios.put(`/api/borrow-requests/${this.returnApprovalForm.id}/approve-return`, {
          approved: this.returnApprovalForm.approved,
          adminRemark: this.returnApprovalForm.adminRemark
        })
        if (response.data.success) {
          this.$message.success(response.data.message || '操作成功')
          this.returnApprovalDialogVisible = false
          this.fetchBorrowRequests()
        } else {
          this.$message.error(response.data.message || '审批归还失败')
        }
      } catch (error) {
        this.$message.error('审批归还失败')
      } finally {
        this.returnSubmitting = false
      }
    },
    
    getStatusTagType(status) {
      const statusMap = {
        'PENDING': 'warning',
        'APPROVED': 'success',
        'REJECTED': 'danger',
        'BORROWED': 'info',
        'PENDING_RETURN': 'warning',
        'RETURNED': 'info',
        'OVERDUE': 'danger',
        'CANCELLED': 'info'
      }
      return statusMap[status] || 'info'
    },
    
    getStatusText(status) {
      const statusMap = {
        'PENDING': '待审批',
        'APPROVED': '已批准',
        'REJECTED': '已拒绝',
        'BORROWED': '已借出',
        'PENDING_RETURN': '申请归还',
        'RETURNED': '已归还',
        'OVERDUE': '已逾期'
      }
      return statusMap[status] || status
    },
    
    formatDateTime(dateTime) {
      if (!dateTime) return '-'
      return new Date(dateTime).toLocaleString('zh-CN')
    },

    getReturnPhotoList(record) {
      const str = record && record.returnPhotos ? String(record.returnPhotos) : ''
      return str
        .split(',')
        .map(s => s.trim())
        .filter(s => s.length > 0)
    },

    toAbsoluteUrl(url) {
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      const base = axios.defaults.baseURL || ''
      if (!base) return url
      return url.startsWith('/') ? `${base}${url}` : `${base}/${url}`
    },
    
    async exportToExcel() {
      this.exporting = true
      try {
        // 获取所有数据（不分页）
        const params = {
          page: 0,
          size: 10000 // 获取大量数据
        }
        if (this.selectedStatus) {
          params.status = this.selectedStatus
        }
        if (this.searchRealName && this.searchRealName.trim()) {
          params.realName = this.searchRealName.trim()
        }
        if (this.searchDeviceName && this.searchDeviceName.trim()) {
          params.deviceName = this.searchDeviceName.trim()
        }
        
        const response = await axios.get('/api/admin/borrow-records', { params })
        
        if (response.data.success) {
          const data = response.data.data || []
          
          // 准备Excel数据
          const excelData = data.map(item => ({
            '申请ID': item.id,
            '用户名': item.userName,
            '真实姓名': item.userRealName || item.userNickname || '-',
            '设备名称': item.deviceName,
            '设备编号': item.deviceNumber,
            '借用原因': item.reason || '-',
            '仪器使用情况': item.deviceUsage || '-',
            '配件信息': item.accessories && item.accessories.length > 0 
              ? item.accessories.map(acc => `${acc.name}×${acc.quantity}`).join('，') 
              : '无配件',
            '借用天数': item.borrowDuration,
            '状态': this.getStatusText(item.status || ''),
            '申请时间': this.formatDateTime(item.createTime),
            '预期归还时间': this.formatDateTime(item.expectedReturnTime),
            '实际归还时间': item.returnTime ? this.formatDateTime(item.returnTime) : '-',
            '管理员备注': item.adminRemark || '-',
            '审批时间': item.approvedAt ? this.formatDateTime(item.approvedAt) : '-'
          }))
          
          // 创建工作簿
          const wb = XLSX.utils.book_new()
          const ws = XLSX.utils.json_to_sheet(excelData)
          
          // 设置列宽
          const colWidths = [
            { wch: 8 },  // 申请ID
            { wch: 15 }, // 用户名
            { wch: 15 }, // 真实姓名
            { wch: 20 }, // 设备名称
            { wch: 15 }, // 设备编号
            { wch: 30 }, // 借用原因
            { wch: 30 }, // 仪器使用情况
            { wch: 25 }, // 配件信息
            { wch: 10 }, // 借用天数
            { wch: 12 }, // 状态
            { wch: 20 }, // 申请时间
            { wch: 20 }, // 预期归还时间
            { wch: 20 }, // 实际归还时间
            { wch: 30 }, // 管理员备注
            { wch: 20 }  // 审批时间
          ]
          ws['!cols'] = colWidths
          
          // 添加工作表到工作簿
          XLSX.utils.book_append_sheet(wb, ws, '借用申请记录')
          
          // 生成文件名
          const now = new Date()
          const fileName = `借用申请记录_${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}.xlsx`
          
          // 下载文件
          XLSX.writeFile(wb, fileName)
          
          this.$message.success(`成功导出 ${data.length} 条记录`)
        } else {
          this.$message.error(response.data.message || '导出失败')
        }
      } catch (error) {
        this.$message.error('导出失败')
      } finally {
        this.exporting = false
      }
    }
  }
}
</script>

<style scoped>
.borrow-request-management {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px 30px;
  border-radius: 10px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.page-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.filter-bar {
  background: white;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.request-list {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.el-table {
  border-radius: 8px;
  overflow: hidden;
}

.el-table th {
  background-color: #f8f9fa;
  color: #495057;
  font-weight: 600;
}

.el-table td {
  padding: 12px 0;
}

.pagination-container {
  margin-top: 20px;
  padding: 15px 0;
  text-align: right;
  border-top: 1px solid #ebeef5;
}

.el-button {
  border-radius: 6px;
  font-weight: 500;
}

.el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.el-button--success {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  border: none;
}

.el-button--danger {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  border: none;
}

.el-button--info {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
  border: none;
  color: #333;
}

.el-tag {
  border-radius: 20px;
  padding: 4px 12px;
  font-weight: 500;
}

.el-select {
  border-radius: 6px;
}

.el-dialog {
  border-radius: 10px;
}

.el-dialog__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  border-radius: 10px 10px 0 0;
}

.el-dialog__title {
  color: white;
  font-weight: 600;
}

.el-form-item__label {
  font-weight: 600;
  color: #333;
}

/* 配件信息样式 */
.accessories-info {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.accessory-tag {
  margin-right: 8px;
  margin-bottom: 4px;
  border-radius: 12px;
  padding: 4px 12px;
}

.no-accessories {
  color: #999;
  font-style: italic;
}

/* 归还照片预览样式 */
.return-photos {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
}
.return-photo {
  width: 80px;
  height: 80px;
  border-radius: 6px;
  overflow: hidden;
}

/* 流程说明样式 */
.flow-doc ol { margin-left: 18px; }
.flow-doc li { margin-bottom: 6px; line-height: 1.6; }
.flow-doc code { background: #f5f7fa; padding: 0 4px; border-radius: 4px; }

/* 响应式设计 */
@media (max-width: 768px) {
  .borrow-request-management {
    padding: 10px;
  }
  
  .page-header {
    padding: 15px 20px;
  }
  
  .page-header h2 {
    font-size: 20px;
  }
  
  .filter-row {
    flex-direction: column;
    align-items: stretch;
  }
  
  .filter-row .el-select,
  .filter-row .el-input {
    width: 100% !important;
    margin-right: 0 !important;
    margin-bottom: 10px;
  }
  
  .el-table {
    font-size: 12px;
  }
  
  .el-button {
    padding: 8px 12px;
    font-size: 12px;
  }
  
  .pagination-container {
    text-align: center;
  }
}
</style>